var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-carousel',_vm._b({attrs:{"indicator-position":_vm.isOutsideIndicator ? 'outside' : 'none',"type":_vm.isCard ? 'card' : '',"direction":_vm.isVertical ? 'vertical' : 'horizontal',"arrow":_vm.carouselShowArrow},on:{"change":function($event){return _vm.$emit('change')}}},'el-carousel',_vm.trimAttrs(_vm.$attrs),false),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }